import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { IGlobalPartnerDetails } from '../models/globalPartnerDetails'

export const getJbpGlobalPartnerDetails = (crudKey?: string) =>
  CrudStore.get(
    CrudStoreItemPartner360.JBPGlobalPartnerDetails,
    crudKey
  ) as Crud<IGlobalPartnerDetails>
